import React from "react";
import ServicePrepHeader from "./ServicePrepHeader/ServicePrepHeader";
import ServicesInterviewPrepData from "./ServicesInterviewPrepData/ServicesInterviewPrepData";
import Contactus from "../CommonPage/Contact/Contactus";
import FaqSection from "../Career_Solutions/FaqSection/FaqSection";
import ScamAlertBanner from "../common_components/scamAlertBanner/ScamAlertBanner";
import TestimonialSection from "../Career_Solutions/TestimonialSection/TestimonialSection";
import You_might_also_like from "../common_components/You_might_also_like/You_might_also_like";

const ServicePrep = () => {
  // 1. Define your dynamic slider data array
  const recommendationsData = [
    {
      imageSrc: "/assets/Images/career_solutions/HighlightServices/prep.svg",
      title: "Featured Profile",
      link: "/career-booster",
      description: "Rank higher, plus stand out in search results – the best way to make a mark.",
      price: "₹699"
    },
    {
      imageSrc: "/assets/Images/career_solutions/HighlightServices/boost.svg",
      title: "Career Booster",
      link: "/career-booster",
      description: "Boost your job search using Featured Profile & Resume Writing.",
      price: "₹4599"
    }
  ];

  // 2. Define your Swiper breakpoints configuration
  const customBreakpoints = {
    576: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 2, // Example: added an extra breakpoint for larger screens
    }
  };

  return (
    <>
      <ServicePrepHeader />

      <ServicesInterviewPrepData />

      {/* 3. Pass the data and breakpoints as props here */}
      <You_might_also_like 
        data={recommendationsData} 
        breakpoints={customBreakpoints} 
      />

      <Contactus />

      <TestimonialSection />

      <FaqSection />

      <ScamAlertBanner />
    </>
  );
};

export default ServicePrep;